import { PlatformLocation } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { Router, RouterOutlet } from '@angular/router';

import { AuthService } from '@dav-core/services/auth.service';
import { LoadPrismicData } from '@dav-store/prismic/prismic.actions';
import { Store } from '@ngrx/store';
import { ApplicationCode } from 'environments/environment.model';

import { ConfigService } from './core/services/config.service';
import { TopAlertComponent } from './shared/components/error/top-alert.component';
import { InitialLoaderComponent } from './shared/components/initial-loader/initial-loader.component';
import { LoaderComponent } from './shared/components/loader/loader.component';
import * as ConfigActions from './store/config/config.actions';
import * as fromRoot from './store/reducers';
import { environment } from '../environments/environment';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  standalone: true,
  imports: [RouterOutlet, TopAlertComponent, InitialLoaderComponent, LoaderComponent],
})
export class AppComponent implements OnInit {
  constructor(
    private titleService: Title,
    private router: Router,
    private platformLocation: PlatformLocation,
    private store: Store<fromRoot.State>,
    private configService: ConfigService,
    private authService: AuthService
  ) {}

  ngOnInit() {
    this.authService.renewToken();

    this.configService.initialLoadingStart();
    localStorage.setItem('domain', environment.application);
    this.store.dispatch(new ConfigActions.GetInitialLayoutAction(environment.application));
    this.setTitle(environment.application);

    this.store.dispatch(new LoadPrismicData());
  }

  setTitle(application: ApplicationCode) {
    const title = '';
    switch (application) {
      default:
        break;
    }
    this.titleService.setTitle(title);
  }
}
